import { useTheme, Button } from '@mui/material';
import Box from '@mui/material/Box';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import isAuthenticated from '../../../../../utils/authUtils';
import { BrandedLogo } from '../../../../common/BrandedLogo/BrandedLogo';
import { MenuContext } from '../MenuContext';
import MenuDivider from '../menuElements/MenuDivider';
import { useHeaderMenuLargeStyles } from '../menuStyles/menuStyles';

import AboutMenu from './AboutMenu';
import { AccountMenu } from './AccountMenu';
import ContactMenu from './ContactMenu';
import HomeMenu from './HomeMenu';
import { PracticeSwitcher } from './PracticeSwitcher';
import ServicesMenu from './ServicesMenu';
import { ThemeSelector } from './themeSelector/ThemeSelector';

export function HeaderMenuLarge() {
  const theme = useTheme();
  const menuContext = useContext(MenuContext);
  const styles = useHeaderMenuLargeStyles(theme, menuContext.selectedTheme);
  const showTrialCta = !isAuthenticated();

  return (
    <Box className={`header-menu-large-wrapper ${styles.root}`}>
      <Box className={styles.leftSection}>
        <Link to={isAuthenticated() ? '/Dashboard' : '/'} style={{ textDecoration: 'none' }}>
          <BrandedLogo height={30} width={120} />
        </Link>
      </Box>
      <Box className={styles.centerSection}>
        {!isAuthenticated() && (
          <>
            <HomeMenu />
            <AboutMenu />
            <ServicesMenu />
            <ContactMenu />
          </>
        )}
      </Box>
      <Box className={styles.rightSection}>
        <ThemeSelector />
        <MenuDivider />
        <PracticeSwitcher />
        <AccountMenu />
        {showTrialCta && (
          <Button
            variant="contained"
            href="/SignUp"
            sx={{
              ml: 1,
              borderRadius: '999px',
              px: 3,
              py: 1,
              textTransform: 'none',
              fontWeight: 700,
              background: 'linear-gradient(135deg, #0f766e 0%, #0ea5e9 100%)',
              boxShadow: '0 12px 28px -16px rgba(14,165,233,0.45)',
              '&:hover': {
                background: 'linear-gradient(135deg, #0ea5e9 0%, #0f766e 100%)',
                boxShadow: '0 16px 32px -18px rgba(14,165,233,0.5)',
              },
            }}
          >
            Start Free Trial
          </Button>
        )}
      </Box>
    </Box>
  );
}
